import React, { useEffect, useRef, useState } from "react";
import { ResponsiveContainer } from "recharts";

/**
 * Sized chart wrapper that only renders Recharts ResponsiveContainer
 * once the parent element has been measured. This eliminates the
 * "width(-1)/height(-1)" warnings Recharts emits during initial mount.
 */
export function Chart({ height = 200, children, className = "" }) {
    const ref = useRef(null);
    const [size, setSize] = useState({ w: 0, h: 0 });

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const measure = () => {
            const rect = el.getBoundingClientRect();
            setSize({ w: rect.width, h: rect.height });
        };
        measure();
        // ResizeObserver keeps it accurate on layout changes
        let ro;
        if (typeof ResizeObserver !== "undefined") {
            ro = new ResizeObserver(measure);
            ro.observe(el);
        } else {
            window.addEventListener("resize", measure);
        }
        return () => {
            if (ro) ro.disconnect();
            else window.removeEventListener("resize", measure);
        };
    }, []);

    const ready = size.w > 0 && size.h > 0;

    return (
        <div ref={ref} className={className} style={{ width: "100%", height }}>
            {ready ? (
                <ResponsiveContainer width={size.w} height={size.h} debounce={20}>
                    {children}
                </ResponsiveContainer>
            ) : null}
        </div>
    );
}
